import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

export function jsonStreamReader<T>(reader: ReadableStreamDefaultReader<Uint8Array>): Observable<T> {
  const decoder = new TextDecoder();
  let requestStreamBuffer: string | null = null;

  function emitParsedValues(subscriber: { next: (value: T) => void }, data: Uint8Array): void {
    for (const parsedValue of parse(data)) {
      subscriber.next(parsedValue);
    }
  }

  function read(): Observable<T> {
    return new Observable(subscriber => {
      reader
        .read()
        .then(function processData({ done, value }): Promise<undefined> | undefined {
          if (value) {
            emitParsedValues(subscriber, value);
          }
          if (done) {
            subscriber.complete();
          } else {
            return reader.read().then(processData);
          }
        })
        .catch(error => {
          subscriber.error(error);
        });
    });
  }

  function parse(data: Uint8Array): T[] {
    let decodedData = decoder.decode(data).trim();
    if (requestStreamBuffer != null) {
      decodedData = requestStreamBuffer.concat(decodedData);
      requestStreamBuffer = null;
    }

    if (decodedData === '') {
      return [];
    }

    const lines = decodedData
      .split(/\r?\n/)
      .map(part => part.trim())
      .filter(part => part !== '');
    if (lines.length > 1) {
      return lines.map(parseToJsonOrBufferize).filter((element: T | undefined): element is T => element != null);
    }

    return decodedData
      .replace(/}{/g, '}:/:{')
      .split(':/:')
      .map(parseToJsonOrBufferize)
      .filter((element: T | undefined): element is T => element != null);
  }

  function parseToJsonOrBufferize(text: string): T | undefined {
    try {
      return JSON.parse(text);
    } catch {
      requestStreamBuffer = text;
    }
  }

  return read().pipe(timeout(10000));
}
